import CloseIcon from "@mui/icons-material/Close";
import { DialogTitle, IconButton, Stack, Typography } from "@mui/material";

import { ink } from "./design/designTokens";

function BreakdownDialogTitle({ title, onClose }) {
  return (
    <DialogTitle component="div" sx={{ pr: 1 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
        <Typography
          component="h2"
          variant="h4"
          sx={{ flex: 1, minWidth: 0, fontWeight: 800, color: ink }}
        >
          {title}
        </Typography>
        <IconButton aria-label="Close" onClick={onClose} edge="end" size="small">
          <CloseIcon />
        </IconButton>
      </Stack>
    </DialogTitle>
  );
}

export default BreakdownDialogTitle;
